export default {
  startsWith: "Comienza con",
  contains: "Contiene",
  notContains: "No contiene",
  endsWith: "Termina con",
  equals: "Es igual",
  notEquals: "No es igual",
  noFilter: "Sin filtro",
  in: "En",
  lt: "Menor que",
  lte: "Menor o igual que",
  gt: "Mayor que",
  gte: "Mayor o igual que",
  dateIs: "La fecha es",
  dateIsNot: "La fecha no es",
  dateBefore: "Fecha anterior",
  dateAfter: "Fecha posterior",
  clear: "Borrar",
  apply: "Aplicar",
  matchAll: "Coincidir con todos",
  matchAny: "Coincidir con cualquier",
  addRule: "Agregar regla",
  removeRule: "Eliminar regla",
  accept: "Aceptar",
  reject: "Rechazar",
  choose: "Elegir",
  upload: "Subir",
  cancel: "Cancelar",
  dayNames: [
    "Domingo",
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
    "Sábado",
  ],
  dayNamesShort: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
  dayNamesMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sá"],
  monthNames: [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ],
  monthNamesShort: [
    "Ene",
    "Feb",
    "Mar",
    "Abr",
    "May",
    "Jun",
    "Jul",
    "Ago",
    "Sep",
    "Oct",
    "Nov",
    "Dic",
  ],
  today: "Hoy",
  weekHeader: "Semana",
  firstDayOfWeek: 0,
  dateFormat: "dd/mm/yy",
  weak: "Débil",
  medium: "Medio",
  strong: "Fuerte",
  passwordPrompt: "Ingrese una contraseña",
  emptyFilterMessage: "Sin resultados",
  emptyMessage: "Sin opciones",
  aria: {
    trueLabel: "Verdadero",
    falseLabel: "Falso",
    nullLabel: "No seleccionado",
    star: "1 estrella",
    stars: "{star} estrellas",
    selectAll: "Seleccionar todo",
    unselectAll: "Deseleccionar todo",
    close: "Cerrar",
  },
}
